import { FC, ReactNode } from 'react';
import ClassNames from 'classnames';
import styles from './Grid.module.scss';

interface IGrid {
  className?: string;
  row?: boolean;
  children?: ReactNode;
  GridRef?: any;
}

const Grid: FC<IGrid> = ({ className, children, row, GridRef }) => {
  return (
    <div ref={GridRef} className={ClassNames(styles.Grid, row && styles.row, className)}>
      {children}
    </div>
  );
};

export default Grid;
